module.exports = __webpack_public_path__ + "static/media/gcdef_10003.99c4c20d.ico";